<!------------------------------------------------------------------------------------>
<!-------------------------------- 품목별 정산 요약 ----------------------------------->
<!------------------------------------------------------------------------------------>
<template>
  <v-container fluid fill-height align-start pa-0 class="pageWrap">
    <v-sheet width="100%" height="100%">
      <div class="d-flex" style="gap:3px;">
        <v-col cols="6">
          <div v-if="noData" class="d-flex align-center justify-center" style="margin:auto;">
            <h4 class="mt-10">데이터가 없습니다.</h4>
          </div>

          <v-card v-else class="chart-status py-2 px-4 mb-2" width="100%">
            <echart class="echartBar pa-5" ref="itemChart" :options="customItemOptions" autoresize @click="chartClick"></echart>
          </v-card>
        </v-col>
        <v-col cols="6">
          <i-search-panel :searchPanel="searchPanel"></i-search-panel>
          <DxDataGrid
            id="itemGrid"
            class="layout-col-height02"
            style="width: 100%; height:100%"
            :ref="gridRef"
            :data-source="gridData"
            :remote-operations="false"
            :hover-state-enabled="true"
            :allow-column-reordering="true"
            :allow-column-resizing="true"
            :row-alternation-enabled="true"
            :column-auto-width="true"
            :show-borders="true"
            :show-row-lines="true"
            :focused-row-enabled="true"
            :selection="{ mode: 'single' }"
            key-expr="id"
          >
            <DxEditing mode="batch" :allow-updating="true" :select-text-on-edit-start="true" />
            <DxColumn data-field="feeTypeNm" data-type="string" alignment="center" width="150px" caption="구분" :allow-editing="false" />
            <DxColumn data-field="name" data-type="string" alignment="center" width="200px" caption="요금제명" :allow-editing="false" />
            <DxColumn
              data-field="feeAmount"
              data-type="number"
              alignment="right"
              width="100px"
              caption="월 요금"
              :allow-editing="false"
              cell-template="amountCellTemplate"
            />
            <template #amountCellTemplate="{ data: cellInfo  }">
              <div>{{ formatToKoreanWon(cellInfo.value) + '원' }}</div>
            </template>
            <DxColumn data-field="value" data-type="string" alignment="center" caption="주문수량" width="80px" :allow-editing="false" />
          </DxDataGrid>
        </v-col>
      </div>
    </v-sheet>
  </v-container>
</template>
<script>
import iSearchPanel from '@/components/common/iSearchPanel.vue'
import BaseDataGrid from '@/views/base/BaseDataGrid.vue' //20220509 LYJ 데이타 그리드 사용시 베이스 추가
import baseview from '@/views/base/baseview.vue' //20220414 LYJ base page 추가
import echart from '@/components/echart/ECharts.vue' // echart 컴포넌트
// 출력 관련
import { Workbook } from 'exceljs'
import { jsPDF } from 'jspdf'
import 'jspdf-autotable'
import { saveAs } from 'file-saver-es'
import { exportDataGrid as exportExcel } from 'devextreme/excel_exporter'
import { exportDataGrid as exportPdf } from 'devextreme/pdf_exporter'
import malgun from '@/assets/font/malgun.ttf'
import { getMonthlyItemSettlementSummary } from '@/api/feeManage/settlementHistory.js'

import itemChartOpts from './data/settlementHistoryItemChartData.js'

export default {
  mixins: [baseview, BaseDataGrid], //20220414 LYJ base page 추가
  name: 'itemHistory',
  components: {
    echart,
    iSearchPanel
  },
  data() {
    return {
      gridRef: 'itemGrid',
      gridData: [],
      searchPanel: true,
      defaultItemChartOptions: itemChartOpts(),
      customItemOptions: itemChartOpts(),
      noData: true
    }
  },
  computed: {},
  beforeMount() {},
  activated() {},
  mounted() {},
  methods: {
    async btnSearch(param, isNotify = true) {
      // 토스 일반요금 정산 내역
      this.customItemOptions = this.defaultItemChartOptions
      this.openLoading()
      getMonthlyItemSettlementSummary(param, true)
        .then(res => {
          this.noData = false
          if (res.list.length === 0) this.noData = true
          this.customItemOptions.series[0].data = res.list
          this.gridData = res.list
        })
        .catch(() => {
          this.endLoading()
        })
        .finally(() => {
          this.endLoading()
        })
    },
    async btnPrint(type, title, docTitle) {
      if (type == 'xls') {
        const workbook = new Workbook()
        const worksheet = workbook.addWorksheet(title)
        exportExcel({
          component: this.GetDataGrid(this.gridRef),
          worksheet,
          autoFilterEnabled: true
        }).then(() => {
          workbook.xlsx.writeBuffer().then(buffer => {
            saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${title}${docTitle}`)
          })
        })
      }
      if (type == 'pdf') {
        const doc = new jsPDF()
        doc.addFont(malgun, 'malgun', 'normal')

        exportPdf({
          jsPDFDocument: doc,
          component: this.GetDataGrid(this.gridRef),
          autoTableOptions: {
            styles: {
              font: 'malgun'
            }
          }
        }).then(() => {
          doc.save(`${title}.pdf`)
        })
      }
    },

    ///////////////////////////////////////
    /*             chart Event             */
    ///////////////////////////////////////
    chartClick(e) {
      let findIndex = this.gridData.findIndex(el => el.name === e.name)
      if (findIndex > -1) {
        this.GetDataGrid(this.gridRef).option('focusedRowIndex', findIndex)
      }
    },
    ///////////////////////////////////////
    /*             etc Event             */
    ///////////////////////////////////////
    formatToKoreanWon(value) {
      if (value) {
        const numberValue = parseFloat(value.toString().replace(/,/g, ''))
        if (!isNaN(numberValue)) {
          return numberValue.toLocaleString('ko-KR')
        }
      } else return 0
    },
    formatDate(date, div = '.') {
      if (!date) return null

      if (date.indexOf(div) == -1) {
        const year = date.substring(0, 4)
        const month = date.substring(4, 6)
        const day = date.substring(6, 8)
        return `${year}${div}${month}${div}${day}`
      } else if (date.indexOf(div) > -1) {
        const [year, month, day] = date.split(div)
        return `${year}${div}${month}${div}${day}`
      } else {
        return date
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/theme/variables.scss';
.echartBar {
  height: calc((100vh - 370px));
}
.chart-status {
  width: 100%;
  // height: 10%;
  // display: flex;
  // justify-content: space-between;
  align-items: center;
  padding: 1rem 20px;
  background: #f3f6fa;
  border-radius: 8px;
  overflow: hidden;
  position: relative;
}
</style>
